import React from "react";
import { useTranslation } from "react-i18next";

import { useConstrainElements } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import { StartStartForm } from "./startStartForm";
import { EndEndForm } from "./endEndForm";
import { StartEndForm } from "./startEndForm";
import { EndStartForm } from "./endStartForm";
import styles from "./styles.scss";

function ConstrainElement({
  constraint,
  origin,
  target,
  project,
  cancel,
}: Props) {
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState(constraint);
  const [deltaOffset, setDeltaOffset] = React.useState<"after" | "before">(
    "after",
  );
  const contraintType = `${constraint.originDateType}_${constraint.targetDateType}`;
  const { constrainElements, isRequestPending, isRequestFailure } =
    useConstrainElements(constraint);

  return (
    <Modal
      header={t(
        `constrainElement.title.${constraint.originDateType}_${constraint.targetDateType}`,
      )}
      close={cancel}
    >
      <div className={styles.constrainElement}>
        {contraintType === "START_START" ? (
          <StartStartForm
            constraint={formData}
            deltaOffset={deltaOffset}
            origin={origin}
            target={target}
            setConstraint={setFormData}
            setDeltaOffset={setDeltaOffset}
          />
        ) : contraintType === "END_END" ? (
          <EndEndForm
            constraint={formData}
            deltaOffset={deltaOffset}
            origin={origin}
            target={target}
            setConstraint={setFormData}
            setDeltaOffset={setDeltaOffset}
          />
        ) : contraintType === "END_START" ? (
          <EndStartForm
            constraint={formData}
            deltaOffset={deltaOffset}
            origin={origin}
            target={target}
            setConstraint={setFormData}
            setDeltaOffset={setDeltaOffset}
          />
        ) : (
          contraintType === "START_END" && (
            <StartEndForm
              constraint={formData}
              deltaOffset={deltaOffset}
              origin={origin}
              target={target}
              setConstraint={setFormData}
              setDeltaOffset={setDeltaOffset}
            />
          )
        )}
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("constrainElement.cancel")}
          </Button>
          <Button
            type="submit"
            status={
              isRequestPending
                ? "pending"
                : isRequestFailure
                  ? "failure"
                  : "none"
            }
            isDisabled={isRequestPending}
            press={() =>
              constrainElements({
                constraint: {
                  ...formData,
                  offsetDays:
                    formData.offsetDays * (deltaOffset === "before" ? -1 : 1),
                },
                project,
              })
            }
          >
            {t("constrainElement.submit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ConstrainElement };
